import { Button, Menu, MenuItem } from "@mui/material";
import React, { useState } from "react";
import { useSingleUserControl } from "../../../context/SuperAdmin/SingleUserControlContext";
import { Estado } from "../../../interfaces/SuperAdmin/Others/iDataEstado";

const StatusAction = () => {
  const { rdsUser, userEdit, isEditing } = useSingleUserControl();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleStatusChange = async (newStatus: Estado) => {
    if (rdsUser && rdsUser.estado !== newStatus) {
      await userEdit(rdsUser.id_usuario, {
        estado: newStatus,
        nombres: rdsUser.nombres,
        apellidos: rdsUser.apellidos,
        pais: rdsUser.pais,
        email: rdsUser.email,
      });
    }
    handleClose();
  };

  return (
    <>
      <Button
        variant="outlined"
        onClick={handleClick}
        disabled={isEditing || !rdsUser}
        sx={{
          borderRadius: "20px",
          textTransform: "none",
          borderColor: "#336B87",
          color: "#336B87",
          fontWeight: "600",
          px: 2,
          "&:hover": {
            borderColor: "#336B87",
            backgroundColor: "rgba(51, 107, 135, 0.08)",
          },
          "&.Mui-disabled": {
            borderColor: "#336B8780",
            color: "#336B8780",
          }
        }}
      >
        {isEditing ? "Cambiando..." : `Estado: ${rdsUser?.estado || "..."}`}
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: { mt: "6px", minWidth: "120px" },
        }}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem 
          onClick={() => handleStatusChange(Estado.ACTIVO)}
          selected={rdsUser?.estado === Estado.ACTIVO}
        >
          Activo
        </MenuItem>
        <MenuItem 
          onClick={() => handleStatusChange(Estado.INACTIVO)}
          selected={rdsUser?.estado === Estado.INACTIVO}
        >
          Inactivo
        </MenuItem>
        <MenuItem 
          onClick={() => handleStatusChange(Estado.ELIMINADO)}
          selected={rdsUser?.estado === Estado.ELIMINADO}
        >
          Eliminado
        </MenuItem>
      </Menu>
    </>
  );
};

export default StatusAction;
